import { render, staticRenderFns } from "./simOpen108.vue?vue&type=template&id=61a2c677&scoped=true&"
import script from "./simOpen108.vue?vue&type=script&lang=js&"
export * from "./simOpen108.vue?vue&type=script&lang=js&"
import style0 from "./simOpen108.vue?vue&type=style&index=0&id=61a2c677&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a2c677",
  null
  
)

export default component.exports